import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { environment } from '../../environments/environment';
import bg from '../../assets/bg.png';
import { IoChatbubbles } from 'react-icons/io5';
const NeedQuestion = () => {
  return (
    <Stack
      variant="section"
      direction="column"
      justifyContent="center"
      sx={{
        mt: 4,
        height: '100px',
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        repeat: 'no-repeat',
      }}
    >
      <Stack direction="row" gap={1} alignItems="center" px={{ xs: 2, sm: 7 }}>
        <IoChatbubbles size={30} color={environment.mainColor} />
        <Typography
          variant="body1"
          sx={{
            fontFamily: 'Jost, sans-serif',
            fontSize: '14px',
            color: '#4D4D4D',
          }}
        >
          Need Help?
        </Typography>
        <Button
          component="a"
          href="tel:+17737321170"
          variant="text"
          aria-label="Call Free +1 (773) 732-1170"
          sx={{
            fontFamily: 'Jost, sans-serif',
            fontSize: '14px',
            color: '#4D4D4D',
            textDecoration: 'none',
          }}
        >
          Free +1 (773)732-1170
        </Button>
      </Stack>
    </Stack>
  );
};

export default NeedQuestion;
